import React from 'react';
import { Tooltip } from '@progress/kendo-react-tooltip';
import { FieldWrapper } from '@progress/kendo-react-form';
import {
    Input, MaskedTextBox, NumericTextBox,
    Checkbox, ColorPicker, Switch, RadioGroup,
    Slider, SliderLabel, RangeSlider, TextArea, Rating
} from '@progress/kendo-react-inputs';
import {DatePicker, TimePicker, DateTimePicker,
    DateRangePicker, DateInput
} from '@progress/kendo-react-dateinputs';
import { Label, Error, Hint, FloatingLabel } from '@progress/kendo-react-labels';
import { DropDownList, AutoComplete, MultiSelect, ComboBox, MultiColumnComboBox } from '@progress/kendo-react-dropdowns';
import TooltipTemplate from '../components/TooltipTemplate';
import ImgTooltipTemplate from '../components/ImgTooltipTemplate';
import { Upload } from '@progress/kendo-react-upload';
import pendingImg from '../images/Pending.png';
import completeImg from '../images/Complete.png';
import{Button} from '@progress/kendo-react-buttons';
 
 
export const FormTitle = (fieldRenderProps) => {
    const {id, name} = fieldRenderProps;
    return(
    <FieldWrapper>
        <div className="row around-xs elementVisible">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <legend id={id}>{name}</legend>
            </div>
        </div>
    </FieldWrapper>
    )
};

export const FormTitleTooltip = (fieldRenderProps) => {
    const {id, name,tooltipPosition, tooltipAchor,tooltipTitle} = fieldRenderProps;
    return(
    <FieldWrapper>
        <div className="row around-xs elementVisible">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div className="legend-title">
                    <legend id={id} >{name}</legend>
                </div>
                <div className="legend-tooltip">
                <Tooltip content={(props) => 
                    <TooltipTemplate title={props.title}/>} 
                        anchorElement={tooltipAchor} position={tooltipPosition} >
                         <span className="k-icon k-i-information legend-tooltip-icon" title={tooltipTitle}></span> 
                </Tooltip> 
                </div>
            </div>
        </div>
    </FieldWrapper>
    )
};


export const FormSubTitle = (fieldRenderProps) => {
    const {id, name} = fieldRenderProps;
    return(
        <FieldWrapper>
        <div className="row around-xs inputPair elementVisible">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div id={id}>{name}</div>
            </div>
        </div>
        </FieldWrapper>
    )
};

export const FormSubTitleDesp = (fieldRenderProps) => {
    const {id, name} = fieldRenderProps;
    return(
        <div className="row around-xs inputPair elementVisible">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div style={{fontSize: "11px"}} id={id}>{name}</div>
        </div>
    </div>
           
    )
};

export const FormSubTitleTooltip = (fieldRenderProps) => {
    const {id, name, tooltipPosition, tooltipAchor,tooltipTitle} = fieldRenderProps;
    return(
        <FieldWrapper>
        <div className="row around-xs inputPair elementVisible">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div id={id}>
                    <span style={{float:"left",paddingRight:"20px",paddingTop:'1.5px'}}>{name}</span>
                    <Tooltip content={(props) => 
                        <TooltipTemplate title={props.title}/>} 
                        anchorElement={tooltipAchor} position={tooltipPosition} >
                         <span className="k-icon k-i-information" 
                            title={tooltipTitle}></span> 
                    </Tooltip>
                </div>
            </div>
        </div>
        </FieldWrapper>
    )
};

export const DelegationChkbox = (fieldRenderProps) => {
    const {id, label, rightLabel, onChange, value, disabled} = fieldRenderProps;

    return (  
    <FieldWrapper style={{paddingLeft:'3%',paddingRight:'3%'}}>
        <div style={{position:'relative',borderRadius:'10rem', margin:'0 auto', boxShadow:'0 0 5rem #b5b5b5', backgroundColor:'#fff'}}>
            <div className="row around-xs inputPair elementVisible" style={{paddingTop:'8px',paddingBottom:'12px'}}>
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6" >
                    <div className="box" style={{paddingLeft:'10px'}}>
                        <Checkbox id={id} label={label} disabled={disabled} checked={value} onChange={onChange}/>
                    </div>
                </div>
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div className="box" >
                        <span className="k-state-default">
                            <label className="k-checkbox-label">
                                {rightLabel}
                            </label> 
                        </span>
                    </div>
                </div>
            </div>
        </div>          
    </FieldWrapper>)
}

export const CusFormSectionLabel = (fieldRenderProps) => {
    const {leftLabelId, leftLabelName, id, name, hasAuthUser, isExpend, doneMyInfo} = fieldRenderProps; 
 
    const toggleHideShow =() => {
        fieldRenderProps.onClick();
    }

    return(
        <div>
        {!hasAuthUser? <FieldWrapper>
        <div className="row around-xs inputPair elementVisible" style={{background:'#F7F7F7',paddingTop:'8px', borderBottom:'1.5px solid #FFC83D',color:'#464646'}}>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" >
            <span className="box text-left" id={leftLabelId}>{leftLabelName}</span> &nbsp;
        </div>
       
        </div>
        </FieldWrapper>:
        <FieldWrapper>
        <div className="row around-xs inputPair elementVisible" style={{background:'#F7F7F7',paddingTop:'7px', borderBottom:'1.5px solid #FFC83D',color:'#464646'}}>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" >

        <div style={{float:'left',width:'55%'}}>
            <span className="box text-left" id={leftLabelId}>{leftLabelName}</span>&nbsp;&nbsp;
            {doneMyInfo?<span><img width="18" height="18" src={completeImg} alt='status' /></span>:<span style={{color:'red', fontSize:'12px'}}><img src={pendingImg} alt='pendingstatus'  width="18" height="18" />&nbsp;Pending Completion with MyInfo</span>}
        </div>
        <div style={{float:'left',width:'45%'}} onClick={toggleHideShow}>
        <span className="k-space-right" style={{fontWeight: "500",float:'right'}} id={id}>
        {name}&nbsp;
         <span>
         {!isExpend?
            <span className="k-icon k-i-arrow-chevron-right" />
         :<span className="k-icon k-i-arrow-chevron-down" />}
         </span>
        
        </span>
            {/* <Label style={{ fontWeight: "500", wordBreak: "break-word"}} className="box" editorId={id}>{name}</Label>      */}
        </div>
        </div>
        </div>
        </FieldWrapper>}
        </div>
    )
}

export const CusFormLabel = (fieldRenderProps) => {
    const {leftLabelId, leftLabelName, id, name} = fieldRenderProps;
    return(
        <div className="row around-xs inputPair elementVisible">
        <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <label className="box text-left" id={leftLabelId}>{leftLabelName}</label>
        </div>
        <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <Label style={{ fontWeight: "500", wordBreak: "break-word"}} className="box" editorId={id}>{name}</Label>     
        </div>
        </div>
    )
}

export const CusFormLabelRtl = (fieldRenderProps) => {
    const {leftLabelId, leftLabelName, id, name} = fieldRenderProps;
    return(
        <div className="row around-xs inputPairPreview elementVisible">
        <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <label className="box text-left" id={leftLabelId} style={{whiteSpace:'pre-line'}}>{leftLabelName}</label>
        </div>
        <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <Label style={{ fontWeight: "500", wordBreak: "break-word",float:"right", textAlign:'right'}} className="box" editorId={id}>{name}</Label>     
        </div>
        </div>
    )
}

export const CusFormLabelFours = (fieldRenderProps) => {
    const {leftLabelId, leftLabelName, id, name, leftLabelId2,leftLabelName2,id2,name2} = fieldRenderProps;
    return(
        <div className="row around-xs inputPairPreview elementVisible">
        <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <label className="box text-left" id={leftLabelId}>{leftLabelName}</label>
        </div>
        <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <Label style={{ fontWeight: "500", wordBreak: "break-word",float:"right", textAlign:'right'}} className="box" editorId={id}>{name}</Label>     
        </div>
        <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <label className="box text-left" id={leftLabelId2}>{leftLabelName2}</label>
        </div>
        <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <Label style={{ fontWeight: "500", wordBreak: "break-word",float:"right", textAlign:'right'}} className="box" editorId={id2}>{name2}</Label>     
        </div>
        </div>
    )
}

export const CusFormLabelTooltip = (fieldRenderProps) =>{
    const {id, name, tooltipPosition, tooltipAchor,tooltipTitle} = fieldRenderProps;
    return(
        <div id={id} style={{display:'flex'}}>  
                <span style={{float:"left",paddingRight:"5px",paddingTop:'1.5px'}}>{name}</span>
                    <Tooltip content={(props) => 
                        <TooltipTemplate title={props.title}/>} 
                        anchorElement={tooltipAchor} position={tooltipPosition} >
                         <span className="k-icon k-i-information" 
                            title={tooltipTitle}></span> 
                    </Tooltip>
            
        </div>
    )
}

export const CusFormInput3 = (fieldRenderProps) => {
    const {
      leftLabelId,
      leftLabelName,
      validationMessage,
      touched,
      label,
      id,
      valid,
      disabled,
      type,
      optional,
      value,
      onChange,
      styles,
      width,
      ...others
    } = fieldRenderProps;
  
    const showValidationMessage = touched && validationMessage;
    const errorId = showValidationMessage ? `${id}_error` : "";
  
    return (
      <div className="row around-xs inputPair elementVisible">
        <div
          className={
            width === "9"
              ? "col-xs-12 col-sm-3 col-md-3 col-lg-3"
              : "col-xs-12 col-sm-6 col-md-6 col-lg-6"
          }
        >
          <div className="box" style={{ marginTop: "5px", fontWeight: "500", color:"#585858" }} id={leftLabelId}>
            {leftLabelName}
          </div>
        </div>
        <div
          className={
            width === "9"
              ? "col-xs-12 col-sm-9 col-md-9 col-lg-9"
              : "col-xs-12 col-sm-6 col-md-6 col-lg-6"
          }
        >
          <div>
            <Input
              style={{ color: styles ? "red" : "black" }}
              valid={valid}
              type={type}
              id={id}
              value={value}
              disabled={disabled}
              onChange={onChange}
              {...others}
            />
            {showValidationMessage && (
              <Error id={errorId}>{validationMessage}</Error>
            )}
          </div>
        </div>
      </div>
    );
  };
  
export const CusFormInput2 = (fieldRenderProps) => {
    const { 
        leftLabelId,
        leftLabelName,
        validationMessage, 
        touched,
        visited,
        modified, 
        label, 
        id, 
        valid,
        disabled, 
        type, 
        optional,
        value,
        onChange,
        ...others } = fieldRenderProps;
      
    const showValidationMessage = value? touched || validationMessage: touched && validationMessage;
    const errorId = showValidationMessage ? `${id}_error` : '';
 
    return (
        <div className="row around-xs inputPair elementVisible">
        <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <div className="box" style={{ marginTop: "5px" }} id={leftLabelId}>
                {leftLabelName}
            </div>
        </div>
        <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6">
        <div >
                <Input
                    valid={valid}
                    type={type}
                    id={id}
                    value={value}
                    disabled={disabled}
                    onChange={onChange}
                    {...others} />
           
                {
                    showValidationMessage &&
                    <Error id={errorId} style={{whiteSpace:'pre-line'}}>{validationMessage}</Error>
                }
            </div>
        </div>
        </div>
    );
};

export const CusFormInput = (fieldRenderProps) => {
    const { 
        leftLabelId,
        leftLabelName,
        validationMessage, 
        touched,
        visited,
        modified, 
        label, 
        id, 
        valid,
        disabled, 
        type, 
        optional,
        value,
        onChange,
        ...others } = fieldRenderProps;
      
    const showValidationMessage =  touched && validationMessage;
    const errorId = showValidationMessage ? `${id}_error` : '';
 
    return (
        <div className="row around-xs inputPair elementVisible">
        <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <div className="box" style={{ marginTop: "5px" }} id={leftLabelId}>
                {leftLabelName}
            </div>
        </div>
        <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6">
        <div>
                <Input
                    valid={valid}
                    type={type}
                    id={id}
                    value={value}
                    disabled={disabled}
                    onChange={onChange}
                    {...others} />
           
                {
                    showValidationMessage &&
                    <Error id={errorId} style={{whiteSpace:'pre-line'}}>{validationMessage}</Error>
                }
            </div>
        </div>
        </div>
    );
};

export const FormInput = (fieldRenderProps) => {
    const { 
        validationMessage, 
        touched, 
        visited,
        modified,
        label, 
        id, 
        valid,
        disabled, 
        hint, 
        type, 
        optional, 
        value,
        onChange,
        ...others } = fieldRenderProps;
      
    const showValidationMessage = modified && validationMessage;
    const errorId = showValidationMessage ? `${id}_error` : '';
 
    return (
    
            <div className={'k-form-field-wrap'} style={{color:"red"}}>
                <Input 
                    valid={valid}
                    type={type}
                    id={id}
                    value={value}
                    disabled={disabled}
                    onChange={onChange}
                    {...others}
                />
                {
                    showValidationMessage &&
                    <Error id={errorId} style={{whiteSpace:'pre-line'}}>{validationMessage}</Error>
                }
            </div>
    );
};

export const FormUpperCaseInput = (fieldRenderProps) => {
    const { 
        validationMessage, 
        touched, 
        visited,
        modified,
        label, 
        id, 
        valid,
        disabled, 
        hint, 
        type, 
        optional, 
        value,
        onChange,
        ...others } = fieldRenderProps;
      
    const showValidationMessage = touched && validationMessage;
    const errorId = showValidationMessage ? `${id}_error` : '';
 
    return (
            <div className={'k-form-field-wrap'} style={{color:"red"}}>
                <Input style={{textTransform:'uppercase'}}
                    valid={valid}
                    type={type}
                    id={id}
                    value={value}
                    disabled={disabled}
                    onChange={onChange}
                    {...others}
                />
                {
                    showValidationMessage &&
                    <Error id={errorId}>{validationMessage}</Error>
                }
            </div>
    );
};

export const FormRadioGroup = (fieldRenderProps) => {
    const { validationMessage, touched, id, label, valid, disabled, hint, visited, modified, ...others } = fieldRenderProps;
    const editorRef = React.useRef(null);

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';
    const labelId = label ? `${id}_label` : '';

    return (
        <FieldWrapper>
            <Label id={labelId} editorRef={editorRef} editorId={id} editorValid={valid} editorDisabled={disabled}>{label}</Label>
            <RadioGroup
                id={id}
                ariaDescribedBy={`${hintId} ${errorId}`}
                ariaLabelledBy={labelId}
                valid={valid}
                disabled={disabled}
                ref={editorRef}
                {...others}
            />
            {
                showHint &&
                <Hint id={hintId}>{hint}</Hint>
            }
            {
                showValidationMessage &&
                <Error id={errorId}>{validationMessage}</Error>
            }
        </FieldWrapper>
    );
};

export const FormNumericTextBox = (fieldRenderProps) => {
    const {
      validationMessage,
      touched,
      label,
      id,
      valid,
      disabled,
      ...others
    } = fieldRenderProps;
    const showValidationMessage = touched && validationMessage;
    const errorId = showValidationMessage ? `${id}_error` : "";
    return (
      <div>
        <NumericTextBox
          ariaDescribedBy={`${errorId}`}
          valid={valid}
          id={id}
          disabled={disabled}
          {...others}
        />
        {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
      </div>
    );
  };

export const TermsFormCheckboxNoErrMsgDisplay = (fieldRenderProps) => {
    const {
        // The meta props of the Field.
        value,validationMessage , touched, visited , modified, valid,
        // The input props of the Field.
         onChange, onFocus, onBlur,        
        // The custom props that you passed to the Field.
        ...others

    } = fieldRenderProps;

    
    const onValueChange = React.useCallback(
        () => {
            // // onChange callback expects argument with 'value' property
            onChange({ value: !value });
        },
        [onChange, value]
    );

    return (
        <div className="row around-xs inputPair elementVisible">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div className="box" onFocus={onFocus} onBlur={onBlur}>
                    <div style={{width:'100%'}}>
                        <div className='dclare-chk-box'>
                            <input type={'checkbox'} className={'k-checkbox'} id={others.id} 
                                onChange={onValueChange} checked={value} />     
                        </div>
                        <div className='dclare-chk-lbl'>
                            <label htmlFor={others.id} >{others.label} </label> 
                        </div>
                    </div>
                </div>
            </div>
        </div>
      );
}

export const TermsFormCheckbox = (fieldRenderProps) => {
    const {
        // The meta props of the Field.
        value,validationMessage , touched, visited , modified, valid,
        // The input props of the Field.
         onChange, onFocus, onBlur,        
        // The custom props that you passed to the Field.
        ...others

    } = fieldRenderProps;

    
    const onValueChange = React.useCallback(
        () => {
            // // onChange callback expects argument with 'value' property
            onChange({ value: !value });
        },
        [onChange, value]
    );

    return (
        <div className="row around-xs inputPair elementVisible">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div className="box" onFocus={onFocus} onBlur={onBlur}>
                    <div style={{width:'100%'}}>
                        <div style={{width:'4%',float:'left'}}>
                            <input type={'checkbox'} className={'k-checkbox'} id={others.id} 
                                onChange={onValueChange} checked={value} />     
                        </div>
                        <div style={{width:'96%',float:'left'}}>
                            <label className={'k-checkbox-label'} htmlFor={others.id} >{others.label} </label> 
                        </div>
                    </div>
                    <div style={{width:'100%'}}>
                        <div style={{width:'5%',float:'left'}}></div>
                    { // Display an error message after the "visited" or "touched" field is set to true.
                        (modified && validationMessage) && (
                            <div style={{width:'95%',float:'right',paddingTop:'5px'}}>
                            <Error style={{display:'inline-block'}}>{validationMessage}</Error>
                            </div>
                            ) 
                    }
                    </div>
                </div>
            </div>
        </div>
      );
}

export const FormCheckbox = (fieldRenderProps) => {
    const { checked,validationMessage, touched, id, valid, disabled, optional, label, visited, modified, ...others } = fieldRenderProps;
    const showValidationMessage = touched && validationMessage;
    const errorId = showValidationMessage ? `${id}_error` : '';
    return (
        <FieldWrapper>
            <Checkbox
                label={label}
                labelOptional={optional}
                valid={valid}
                id={id}
                checked={checked}
                disabled={disabled}
                {...others}
            />
            {
                showValidationMessage &&
                <Error id={errorId}>{validationMessage}</Error>
            }
        </FieldWrapper>
    );
};

export const FormSwitch = (fieldRenderProps) => {
    const { validationMessage, touched, label, optional, id, valid, disabled, hint, ...others } = fieldRenderProps;
    const editorRef = React.useRef(null);

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';
    const labelId = label ? `${id}_label` : '';

    return (
        <FieldWrapper>
            <Label
                id={labelId}
                editorRef={editorRef}
                editorId={id}
                editorValid={valid}
                editorDisabled={disabled}
                optional={optional}
            >
                {label}
            </Label>
            <Switch
                ref={editorRef}
                ariaLabelledBy={labelId}
                ariaDescribedBy={`${hintId} ${errorId}`}
                valid={valid}
                id={id}
                disabled={disabled}
                {...others}
            />
            {
                showHint &&
                <Hint id={hintId}>{hint}</Hint>
            }
            {
                showValidationMessage &&
                <Error id={errorId}>{validationMessage}</Error>
            }
        </FieldWrapper>
    );
};

export const FormMaskedTextBox = (fieldRenderProps) => {
    const { validationMessage, touched, label, id, valid, hint, optional, ...others } = fieldRenderProps;

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';

    return (
        <FieldWrapper>
            <Label editorId={id} editorValid={valid} optional={optional}>{label}</Label>
            <div className={'k-form-field-wrap'}>
                <MaskedTextBox
                    ariaDescribedBy={`${hintId} ${errorId}`}
                    valid={valid}
                    id={id}
                    {...others}
                />
                {
                    showHint &&
                    <Hint id={hintId}>{hint}</Hint>
                }
                {
                    showValidationMessage &&
                    <Error id={errorId}>{validationMessage}</Error>
                }
            </div>
        </FieldWrapper>
    );
};

export const FormTextArea = (fieldRenderProps) => {
    const { validationMessage, touched, label, id, valid, hint, disabled, optional, ...others } = fieldRenderProps;

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';

    return (
        <FieldWrapper>
            <Label editorId={id} editorValid={valid} optional={optional}>{label}</Label>
            <TextArea
                valid={valid}
                id={id}
                disabled={disabled}
                ariaDescribedBy={`${hintId} ${errorId}`}
                {...others}
            />
            {
                showHint &&
                <Hint id={hintId}>{hint}</Hint>
            }
            {
                showValidationMessage &&
                <Error id={errorId}>{validationMessage}</Error>
            }
        </FieldWrapper>
    );
};

export const FormColorPicker = (fieldRenderProps) => {
    const { validationMessage, touched, label, id, valid, disabled, hint, wrapperStyle, ...others } = fieldRenderProps;
    const editorRef = React.useRef(null);

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';
    const labelId = label ? `${id}_label` : '';

    return (
        <FieldWrapper style={wrapperStyle}>
            <Label
                id={labelId}
                editorRef={editorRef}
                editorId={id}
                editorValid={valid}
                editorDisabled={disabled}
            >
                {label}
            </Label>
            <ColorPicker
                ariaLabelledBy={labelId}
                ariaDescribedBy={`${hintId} ${errorId}`}
                ref={editorRef}
                valid={valid}
                id={id}
                disabled={disabled}
                {...others}
            />
            {
                showHint &&
                <Hint id={hintId}>{hint}</Hint>
            }
            {
                showValidationMessage &&
                <Error id={errorId}>{validationMessage}</Error>
            }
        </FieldWrapper>
    );
};

export const FormSlider = (fieldRenderProps) => {
    const { validationMessage, touched, label, id, valid, disabled, hint, data, ...others } = fieldRenderProps;

    const editorRef = React.useRef(null);
    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';
    const labelId = label ? `${id}_label` : '';

    return (
        <FieldWrapper>
            <Label
                id={labelId}
                editorRef={editorRef}
                editorId={id}
                editorValid={valid}
                editorDisabled={disabled}
            >
                {label}
            </Label>
            <Slider
                ariaLabelledBy={labelId}
                ariaDescribedBy={`${hintId} ${errorId}`}
                ref={editorRef}
                valid={valid}
                id={id}
                disabled={disabled}
                {...others}
            >
                {
                    data.map(value => (
                        <SliderLabel
                            title={value}
                            key={value}
                            position={value}
                        >
                            {value.toString()}
                        </SliderLabel>
                    ))
                }
            </Slider>
            {
                showHint &&
                <Hint id={hintId}>{hint}</Hint>
            }
            {
                showValidationMessage &&
                <Error id={errorId}>{validationMessage}</Error>
            }
        </FieldWrapper>
    );
};

export const FormRangeSlider = (fieldRenderProps) => {
    const { validationMessage, touched, label, id, valid, hint, disabled, data, ...others } = fieldRenderProps;

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';

    return (
        <FieldWrapper>
            <Label editorId={id} editorValid={valid}>{label}</Label>
            <RangeSlider
                valid={valid}
                id={id}
                disabled={disabled}
                ariaDescribedBy={`${hintId} ${errorId}`}
                {...others}
            >{
                data.map(value => {
                    return  (
                    <SliderLabel
                        key={value}
                        position={value}
                    >
                        {value.toString()}
                    </SliderLabel>
                )})
            }
            </RangeSlider>
            {
                showValidationMessage &&
                <Error id={errorId}>{validationMessage}</Error>
            }
        </FieldWrapper>
    );
};

export const FormRating = (fieldRenderProps) => {
    const { validationMessage, touched, label, id, valid, hint, disabled, optional, ...others } = fieldRenderProps;

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';

    return (
        <FieldWrapper>
            <Label editorId={id} editorValid={valid} optional={optional}>{label}</Label>
            <Rating
                valid={valid}
                id={id}
                disabled={disabled}
                ariaDescribedBy={`${hintId} ${errorId}`}
                {...others}
            />
            {
                showValidationMessage &&
                <Error id={errorId}>{validationMessage}</Error>
            }
        </FieldWrapper>
    );
};


export const FormDropDownList = (fieldRenderProps) => {
    const {dataItemKey,textField,data,onChange,value,validationMessage, touched,  id, wrapperStyle} = fieldRenderProps;
 

    const showValidationMessage = touched && validationMessage;
 
    const errorId = showValidationMessage ? `${id}_error` : '';
 

    return (
        <FieldWrapper style={wrapperStyle}>
    
        <DropDownList
              data={data}
              textField={textField}
              dataItemKey={dataItemKey}
              value={value}
              onChange={onChange}
                />
            {
                showValidationMessage &&
                <Error id={errorId}>{validationMessage}</Error>
            }
        </FieldWrapper>
    );
};

export const FormAutoComplete = (fieldRenderProps) => {
    const { validationMessage, touched, label, id, valid, disabled, hint, wrapperStyle, ...others } = fieldRenderProps;
    const editorRef = React.useRef(null);

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';
    const labelId = label ? `${id}_label` : '';

    return (
        <FieldWrapper style={wrapperStyle}>
            <Label
                id={labelId}
                editorRef={editorRef}
                editorId={id}
                editorValid={valid}
                editorDisabled={disabled}
            >
                {label}
            </Label>
            <AutoComplete
                ariaLabelledBy={labelId}
                ariaDescribedBy={`${hintId} ${errorId}`}
                ref={editorRef}
                valid={valid}
                id={id}
                disabled={disabled}
                {...others}
            />
            {
                showHint &&
                <Hint id={hintId}>{hint}</Hint>
            }
            {
                showValidationMessage &&
                <Error id={errorId}>{validationMessage}</Error>
            }
        </FieldWrapper>
    );
};

export const CusFormComboBox = (fieldRenderProps) => {
    const {leftLabelId,leftLabelName, validationMessage, touched, label, id, valid, disabled, hint, wrapperStyle, ...others } = fieldRenderProps;
 
    const editorRef = React.useRef(null);

    const showValidationMessage = touched && validationMessage;
    const errorId = showValidationMessage ? `${id}_error` : '';
    const labelId = label ? `${id}_label` : '';

    return( 
        <div className="row around-xs inputPair elementVisible">
            <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <div className="box" style={{ marginTop: "5px" }} id={leftLabelId}>
                    {leftLabelName}
                </div>
            </div>
            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
            <div className="box">
                    <Label id={labelId} editorRef={editorRef} editorId={id} editorValid={valid} editorDisabled={disabled}>
                        {label}
                    </Label>
                    <ComboBox
                        ariaLabelledBy={labelId}
                        ref={editorRef}
                        valid={valid}
                        id={id}
                        disabled={disabled}
                        {...others}
                    />
                    {
                        showValidationMessage &&
                        <Error id={errorId}>{validationMessage}</Error>
                    }
            </div>
            </div>
        </div>
       
    )
}

export const FormComboBox = (fieldRenderProps) => {
    const { validationMessage, touched, label, id, valid, disabled, wrapperStyle, ...others } = fieldRenderProps;
    
    const editorRef = React.useRef(null);

    const showValidationMessage = touched && validationMessage;
 
    const errorId = showValidationMessage ? `${id}_error` : '';
    const labelId = label ? `${id}_label` : '';
 
    return (
        <div>
            <ComboBox
                ariaLabelledBy={labelId}
                ref={editorRef}
                valid={valid}
                id={id}
                disabled={disabled}
                {...others}
            />
            {
                showValidationMessage &&
                <Error id={errorId}>{validationMessage}</Error>
            }
        </div>
    );
};

export const FormMultiColumnComboBox = (fieldRenderProps) => {
    const { validationMessage, touched, label, id, valid, disabled, hint, wrapperStyle, ...others } = fieldRenderProps;
    const editorRef = React.useRef(null);

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';
    const labelId = label ? `${id}_label` : '';

    const columns = [
        { field: 'id', header: <span>header</span>, width: '100px' },
        { field: 'name', header: 'Name', width: '300px' },
        { field: 'position', header: 'Position', width: '300px' }
    ];

    return (
        <FieldWrapper style={wrapperStyle}>
            <Label id={labelId} editorRef={editorRef} editorId={id} editorValid={valid} editorDisabled={disabled}>
                {label}
            </Label>
            <MultiColumnComboBox
                ariaLabelledBy={labelId}
                ariaDescribedBy={`${hintId} ${errorId}`}
                ref={editorRef}
                valid={valid}
                id={id}
                disabled={disabled}
                columns={columns}
                textField={'name'}
                {...others}
            />
            {
                showHint &&
                <Hint id={hintId}>{hint}</Hint>
            }
            {
                showValidationMessage &&
                <Error id={errorId}>{validationMessage}</Error>
            }
        </FieldWrapper>
    );
};

export const FormMultiSelect = (fieldRenderProps) => {
    const { validationMessage, touched, label, id, valid, disabled, hint, wrapperStyle, ...others } = fieldRenderProps;
    const editorRef = React.useRef(null);
    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : "";
    const errorId = showValidationMessage ? `${id}_error` : "";
    const labelId = label ? `${id}_label` : "";

    return (
        <FieldWrapper style={wrapperStyle}>
            <Label
                id={labelId}
                editorRef={editorRef}
                editorId={id}
                editorValid={valid}
                editorDisabled={disabled}
            >
                {label}
            </Label>
            <MultiSelect
                ariaLabelledBy={labelId}
                ariaDescribedBy={`${hintId} ${errorId}`}
                ref={editorRef}
                valid={valid}
                id={id}
                disabled={disabled}
                {...others}
            />
            {showHint && <Hint id={hintId}>{hint}</Hint>}
            {showValidationMessage && <Error id={errorId}>{validationMessage}</Error>}
        </FieldWrapper>
    );
};


export const FormDatePicker = (fieldRenderProps) => {
    const {
        validationMessage, touched, label, id, valid,
        disabled, hint, wrapperStyle, hintDirection, ...others
    } = fieldRenderProps;

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';
    const labelId = label ? `${id}_label` : '';

    return (
        <FieldWrapper style={wrapperStyle}>
            <Label id={labelId} editorId={id} editorValid={valid} editorDisabled={disabled}>
                {label}
            </Label>
            <div className={'k-form-field-wrap'}>
                <DatePicker
                    ariaLabelledBy={labelId}
                    ariaDescribedBy={`${hintId} ${errorId}`}
                    valid={valid}
                    id={id}
                    disabled={disabled}
                    {...others}
                />
                {
                    showHint &&
                    <Hint id={hintId} direction={hintDirection}>{hint}</Hint>
                }
                {
                    showValidationMessage &&
                    <Error id={errorId}>{validationMessage}</Error>
                }
            </div>
        </FieldWrapper>
    );
};

export const FormDateTimePicker = (fieldRenderProps) => {
    const { validationMessage, touched, label, id, valid, disabled, hint, wrapperStyle, ...others } = fieldRenderProps;

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';
    const labelId = label ? `${id}_label` : '';

    return (
        <FieldWrapper style={wrapperStyle}>
            <Label id={labelId} editorId={id} editorValid={valid} editorDisabled={disabled}>
                {label}
            </Label>
            <DateTimePicker
                ariaLabelledBy={labelId}
                ariaDescribedBy={`${hintId} ${errorId}`}
                valid={valid}
                id={id}
                disabled={disabled}
                {...others}
            />
            {
                showHint &&
                <Hint id={hintId}>{hint}</Hint>
            }
            {
                showValidationMessage &&
                <Error id={errorId}>{validationMessage}</Error>
            }
        </FieldWrapper>
    );
};

export const FormTimePicker = (fieldRenderProps) => {
    const { validationMessage, touched, label, id, valid, disabled, hint, wrapperStyle, ...others } = fieldRenderProps;

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';
    const labelId = label ? `${id}_label` : '';

    return (
        <FieldWrapper style={wrapperStyle}>
            <Label id={labelId} editorId={id} editorValid={valid} editorDisabled={disabled}>
                {label}
            </Label>
            <TimePicker
                ariaLabelledBy={labelId}
                ariaDescribedBy={`${hintId} ${errorId}`}
                valid={valid}
                id={id}
                disabled={disabled}
                {...others}
            />
            {
                showHint &&
                <Hint id={hintId}>{hint}</Hint>
            }
            {
                showValidationMessage &&
                <Error id={errorId}>{validationMessage}</Error>
            }
        </FieldWrapper>
    );
};

export const FormDateInput = (fieldRenderProps) => {
    const { validationMessage, touched, label, id, valid, disabled, hint, wrapperStyle, ...others } = fieldRenderProps;

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';
    const labelId = label ? `${id}_label` : '';

    return (
        <FieldWrapper style={wrapperStyle}>
            <Label id={labelId} editorId={id} editorValid={valid} editorDisabled={disabled}>
                {label}
            </Label>
            <DateInput
                ariaLabelledBy={labelId}
                ariaDescribedBy={`${hintId} ${errorId}`}
                valid={valid}
                id={id}
                disabled={disabled}
                {...others}
            />
            {
                showHint &&
                <Hint id={hintId}>{hint}</Hint>
            }
            {
                showValidationMessage &&
                <Error id={errorId}>{validationMessage}</Error>
            }
        </FieldWrapper>
    );
};

export const FormDateRangePicker = (fieldRenderProps) => {
    const { validationMessage, touched, label, id, valid, disabled, hint, wrapperStyle, ...others } = fieldRenderProps;
    const editorRef = React.useRef(null);

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';
    const labelId = label ? `${id}_label` : '';

    return (
        <FieldWrapper style={wrapperStyle}>
            <Label id={labelId} editorRef={editorRef} editorId={id} editorValid={valid} editorDisabled={disabled}>
                {label}
            </Label>
            <DateRangePicker
                ariaLabelledBy={labelId}
                ariaDescribedBy={`${hintId} ${errorId}`}
                ref={editorRef}
                valid={valid}
                id={id}
                disabled={disabled}
                {...others}
            />
            {
                showHint &&
                <Hint id={hintId}>{hint}</Hint>
            }
            {
                showValidationMessage &&
                <Error id={errorId}>{validationMessage}</Error>
            }
        </FieldWrapper>
    );
};

export const FormFloatingNumericTextBox = (fieldRenderProps) => {
    const { validationMessage, touched, label, id, valid, disabled, hint, optional, value, ...others } = fieldRenderProps;

    const showValidationMessage = touched && validationMessage;
    const showHint = !showValidationMessage && hint;
    const hintId = showHint ? `${id}_hint` : '';
    const errorId = showValidationMessage ? `${id}_error` : '';

    return (
        <FieldWrapper>
            <FloatingLabel
                optional={optional}
                editorValue={value}
                editorId={id}
                editorValid={valid}
                editorDisabled={disabled}
                label={label}
            >
                <NumericTextBox
                    ariaDescribedBy={`${hintId} ${errorId}`}
                    value={value}
                    valid={valid}
                    id={id}
                    disabled={disabled}
                    {...others}
                />
            </FloatingLabel>
            {
                showHint &&
                <Hint id={hintId}>{hint}</Hint>
            }
            {
                showValidationMessage &&
                <Error id={errorId}>{validationMessage}</Error>
            }
        </FieldWrapper>
    );
};

export const FormUpload = (fieldRenderProps) => {
    const { valid, value, id, optional, label, validationMessage, touched,tooltipPosition, tooltipAchor,tooltipTitle,tooltipDesc, isTooltipImg,...others } = fieldRenderProps;

    const showValidationMessage = touched && validationMessage;
 
    const errorId = showValidationMessage ? `${id}_error` : '';
    const labelId = label ? `${id}_label` : '';
 
    const onAddHandler = (event) => {
 
        fieldRenderProps.onChange({ value: event.newState });
    };

    const onRemoveHandler = (event) => {
      
        fieldRenderProps.onChange({ value: event.newState });
    };

    const onProgress = (event) => {
        fieldRenderProps.onChange({ value: event.newState });
    };
    
    return (
      <FieldWrapper>
            <div className="row around-xs inputPair elementVisible">
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div style={{ width:"95%", float:'left',whiteSpace:'pre-line'}}>
                        <Label id={labelId} editorId={id} editorValid={valid} optional={optional}>
                        {label}
                        </Label>
                    </div>
                    <div style={{width:"5%",float:'right'}}>
                    {isTooltipImg? <Tooltip content={(props) => 
                        <ImgTooltipTemplate title={props.title} desc={tooltipDesc} />} 
                            anchorElement={tooltipAchor} position={tooltipPosition} >
                            <span className="k-icon k-i-information" title={tooltipTitle} ></span> 
                    </Tooltip>:
                    <Tooltip content={(props) => 
                        <TooltipTemplate title={props.title}/>} 
                        anchorElement={tooltipAchor} position={tooltipPosition} >
                         <span className="k-icon k-i-information" title={tooltipTitle}></span> 
                    </Tooltip>}
                    </div>
                </div>
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <Upload id={id} valid={valid} autoUpload={false} showActionButtons={false}
                    multiple={false} files={value} onAdd={onAddHandler} onRemove={onRemoveHandler}
                    onProgress={onProgress}
                    ariaDescribedBy={`${errorId}`}
                    ariaLabelledBy={labelId}
                    {...others} />
                   
                    { showValidationMessage && <Error id={errorId}>{validationMessage}</Error> }
                </div>
            </div>
      </FieldWrapper>
    );
};

export const FormUploadView = (fieldRenderProps) => {
    const { uploadedFileName, isFileUploaded, valid, value, id, optional, label, validationMessage, touched,tooltipPosition, tooltipAchor,tooltipTitle,tooltipDesc, isTooltipImg,...others } = fieldRenderProps;

    const showValidationMessage = touched && validationMessage;
 
    const errorId = showValidationMessage ? `${id}_error` : '';
    const labelId = label ? `${id}_label` : '';
 
    const onAddHandler = (event) => {
 
        fieldRenderProps.onChange({ value: event.newState });
    };

    const onRemoveHandler = (event) => {
      
        fieldRenderProps.onChange({ value: event.newState });
    };

    const onProgress = (event) => {
        fieldRenderProps.onChange({ value: event.newState });
    };

    const handleView = (e) => {
        fieldRenderProps.onViewClick(e);
    }
    return (
      <FieldWrapper>
            <div className="row around-xs inputPair elementVisible">
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <div style={{ width:"95%", float:'left',whiteSpace:'pre-line'}}>
                        <Label id={labelId} editorId={id} editorValid={valid} optional={optional}>
                        {label}
                        </Label>
                    </div>
                    <div style={{width:"5%",float:'right'}}>
                    {isTooltipImg? <Tooltip content={(props) => 
                        <ImgTooltipTemplate title={props.title} desc={tooltipDesc} />} 
                            anchorElement={'target'} position={'right'} >
                            <span className="k-icon k-i-information" title={tooltipTitle} ></span> 
                    </Tooltip>:
                    <Tooltip content={(props) => 
                        <TooltipTemplate title={props.title}/>} 
                        anchorElement={tooltipAchor} position={tooltipPosition} >
                         <span className="k-icon k-i-information" title={tooltipTitle}></span> 
                    </Tooltip>}
                    </div>
                </div>
                <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                <Upload id={id} valid={valid} autoUpload={false} showActionButtons={false}
                    multiple={false} 
                    files={value}
                    onAdd={onAddHandler} 
                    onRemove={onRemoveHandler}
                    onProgress={onProgress}
                    ariaDescribedBy={`${errorId}`}
                    ariaLabelledBy={labelId}
                    {...others} />
                </div>
            </div>
                    
            {isFileUploaded &&
            <div className="row around-xs inputPair elementVisible">
                <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6">
                </div>
                <div className=" col-xs-12 col-sm-6 col-md-6 col-lg-6">
                    <Button look="outline"style={{whiteSpace:'break-spaces'}} className="btSize3" onClick={handleView}><span className="k-file-group k-icon k-i-file-image"></span>View
                    </Button>
                </div>
            </div>}
      </FieldWrapper>
    );
};